module.exports = __webpack_public_path__ + "static/media/golfer-5-b.e0ce2de8.png";